import type { LocalizationContext } from '@athena-lib/i18n';

export default function formatSize(
  width: string | number,
  height: string | number,
  locale: LocalizationContext,
  convert: boolean,
): string {
  const inchCountries = ['us'];
  const unit: 'cm' | 'inch' = inchCountries.includes(locale.countryCode) ? 'inch' : 'cm';
  const formatUnit = {
    width: unit === 'cm' ? '' : '"',
    height: unit === 'cm' ? ' cm' : '"',
  };

  const parsedWidth = Number.parseFloat(width as string);
  const parsedHeight = Number.parseFloat(height as string);
  const decimals = unit === 'inch' ? 1 : 2;

  const conversionFactor = unit == 'inch' ? 25.4 : 10;

  const widthFormatted = convert
    ? `${parseFloat((parsedWidth / conversionFactor).toFixed(decimals))}${formatUnit.width}`
    : `${parsedWidth}${formatUnit.width}`;
  const heightFormatted = convert
    ? `${parseFloat((parsedHeight / conversionFactor).toFixed(decimals))}${formatUnit.height}`
    : `${parsedHeight}${formatUnit.height}`;

  return `${widthFormatted} x ${heightFormatted}`;
}
